<template>
  <div class="info-list-wrapper">
    <div v-if="shopDataList" :style="{ transform: infoListTranslate }" class="info-list">
      <div @click="showAndHideInfoList" class="header">
        <div class="bar"></div>
        <!--TODO: 这边显示的文案会随着是不是路线而变化-->
        <div v-if="barTitle" class="text">{{barTitle}}</div>
      </div>
      <div class="list-container" ref="container" @scroll="handleScroll">
        <ul class="list">
          <li v-for="(item, index) in shopDataList" :key="item.id + index" class="list-item">
            <Info-item v-if="item" :userPosition="userPosition" :activityInfo="activityInfo" :data="item" />
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isShowInfoList" class="_mask" @click="showAndHideInfoList" @touchmove="onTouchmove"></div>
  </div>
</template>

<script>
import InfoItem from '../InfoItem'
export default {
  components: {
    InfoItem
  },
  props: {
    page: {
      default: 0
    },
    activityInfo: {
      default: null
    },
    userPosition: {
      default: null
    },
    data: {
      require: true,
      default: null
    },
    getShopInfo: {
      type: Function,
      default: () => {}
    },
    shopDataList: {
      require: true,
      default: []
    },
    isShowInfoList: {
      type: Boolean,
      default: false
    },
    barTitle: {
      type: String,
      default: ''
    }
  },
  watch: {
    isShowInfoList (newVal) {
      console.log('watch isShowInfoList: ', newVal)
      if (newVal) {
        this.$refs['container']?.scrollTo(0, 0)
      }
      this.infoListTranslate = newVal === true ? 'translate(-50%, 0)' : 'translate(-50%, calc(100% + 0.1rem))'
    }
  },
  data: function () {
    return {
      infoListTranslate: 'translate(-50%, calc(100% + 0.1rem))'
    }
  },
  methods: {
    handleScroll (e) {
      const target = e.currentTarget
      const scrollTop = target.scrollTop
      const scrollHeight = target.scrollHeight
      const mapHeight = target.clientHeight
      if (scrollTop + mapHeight >= scrollHeight - 0.1) {
        // 现在列表页面直接显示，不需要滚动加载，后续如果需要，则可以补上
        this.getShopInfo({}, {page: this.page + 1})
      }
    },
    showAndHideInfoList () {
      this.$emit('update:isShowInfoList', false)
    },
    onTouchmove(e) {
      // 修复苹果手机滑动列表误触mask导致滑动不了的问题
      e.stopPropagation()
      e.preventDefault()
    }
  },
  mounted () {
    // console.log("mounted", this.isShowInfoList)
  }
}
</script>

<style scoped="scoped" lang="scss">
.info-list-wrapper {
  .info-list {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 7.1rem;
    height: 5.66rem;
    box-shadow: 0 -0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
    border-radius: 0.3rem 0.3rem 0 0;
    transition: all 0.5s;
    z-index: 1003;
    background: #f5f4f4;

    .header {
      width: 7.1rem;
      // height: 0.48rem;
      border-radius: 0.3rem 0.3rem 0 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      background: #fff;
      .bar {
        margin: 0.15rem 0 0.1rem;
        width: 0.8rem;
        height: 0.18rem;
        background: url(../../../../assets/images/list_icon_more.png) no-repeat center;
        background-size: 0.8rem;
      }
      .text {
        font-size: 0.26rem;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
      }
    }

    .list-container {
      width: 7.1rem;
      position: relative;
      height: 5.18rem;
      background: #fff;
      overflow: scroll;

      .list {
        width: 7.1rem;
        display: flex;
        align-items: center;
        flex-flow: column nowrap;
        justify-content: flex-start;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;

        .list-item {
          width: 100%;
          min-height: auto;
        }
      }
    }
  }

  ._mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1002;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
